module.exports = __webpack_public_path__ + "static/img/unit-6.87b8b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/unit-6.png
// module id = VdUE
// module chunks = 52